import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import reducer from './reducer';
import saga from './saga';

const withOfferChildsReducer = injectReducer({
  key: 'offerChilds',
  reducer,
});
const withOfferChildsSaga = injectSaga({ key: 'offerChilds', saga });

export { withOfferChildsReducer, withOfferChildsSaga };
